
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.6"}},[_c('path',{attrs:{"d":"M16.77 13.23h0a5 5 0 010 7.07l-4.86 4.86a5 5 0 01-7.07 0h0a5 5 0 010-7.07l2.65-2.65"}}),_c('path',{attrs:{"d":"M13.23 16.77h0a5 5 0 010-7.07l4.86-4.86a5 5 0 017.07 0h0a5 5 0 010 7.07l-2.65 2.65"}})])])
          )
        }
      }
    